import * as React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";

interface IDeleteBauvorhabenDialogProps {
    open: boolean;
    error: boolean;
    name: string;
    onClose: () => void;
    onConfirmDelete: (confirm?: boolean) => void;
}

export default function DeleteBauvorhabenDialog(props: IDeleteBauvorhabenDialogProps) {
    const { open, error, name, onClose, onConfirmDelete } = props;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{}}
        >
            <DialogTitle>Bauvorhaben löschen?</DialogTitle>
            <DialogContent>
                {error ? (
                    <div style={{marginBottom: '16px'}}>
                        <Typography color="error" sx={{paddingBottom: '1rem', fontWeight: 'bold'}}>
                            Beim Löschen ist ein Fehler aufgetreten. es ist für das Bauvorhaben bereits eine Zeiterfassung vorhanden.
                            Solltest du das Bauvorhaben dennoch löschen wollen, wird bei allen vorhandenen Einträgen das Bauvorhaben entfernt.
                            Achtung!
                        </Typography>
                        <Button onClick={() => onConfirmDelete(true)} variant={'contained'} color="error">Ganz sicher Löschen!</Button>
                    </div>
                ) : <></>}
                Bauvorhaben "{name}" wirklich dauerhaft löschen. Dieser Schritt kann nicht rückgängig gemacht werden.
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant='outlined'>Abbrechen</Button>
                <Button onClick={() => onConfirmDelete()} variant={'contained'} color="error">Löschen</Button>
            </DialogActions>
        </Dialog>
    );
} 